import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import cx from "classnames";
import CheckIcon from "@mui/icons-material/Check";
import "./EnrollmentProgress.css";
import { Typography } from "@mui/material";
import { useTranslate } from "../../hooks/useTranslate";
import useStatuses from "../../context/status/useStatuses";
import { isVersionUS } from "../../services/versionService";
import StatusBox from "../StatusBox";
import { useStudents } from "../../context/students";
import Preloader from "../Preloader";

const steps = [
    {
        key: "responsibleAdults",
        schools: ["KUS", "KIH"],
        order: 1,
    },
    {
        key: "studentDetails",
        schools: ["KUS", "KIH"],
        order: 2,
    },
    {
        key: "previousEducation",
        schools: ["KUS", "KIH"],
        order: 3,
    },
    {
        key: "enrolmentAgreement",
        schools: ["KUS", "KIH"],
        order: 4,
    },
    // {
    //     key: "consultationCall",
    //     schools: ["KUS", "KIH"],
    //     studySchedules: ["Part Time"],
    //     order: isVersionUS ? 5 : 4,
    // },
    // {
    //     key: "courseSelection",
    //     schools: ["KUS", "KIH"],
    //     studySchedules: ["Part Time"],
    //     order: 6,
    // },
    {
        key: "tuitionBilling",
        schools: ["KUS", "KIH"],
        order: 5,
    },
]
    .toSorted((a, b) => a.order - b.order);

const StepIcon = ({ completed, active }) => (
    <span
        className={cx(
            "enrollment-progress__icon",
            { "enrollment-progress__icon--active": active },
            { "enrollment-progress__icon--completed": completed },
        )}
    >
        {completed && <CheckIcon />}
    </span>
);

const EnrollmentProgress = (props) => {
    const {
        isLoading, stepsProgress = [], school, taskPanelsKeys,
    } = props;
    const { t } = useTranslate();
    const { activeStudent } = useStudents();
    const { showConsultationCall } = useStatuses();

    const activeSteps = steps
        .filter((step) => (step.key === "consultationCall" && showConsultationCall ? true : step.schools.includes(school)))
        .filter((step) => taskPanelsKeys.includes(step.key));

    const hasActiveSteps = activeSteps.length > 0;
    const completedSteps = hasActiveSteps ? activeSteps.filter((step) => stepsProgress[step.key]?.completed) : [];
    const completionPercent = hasActiveSteps ? Math.round((completedSteps.length / activeSteps.length) * 100) : 0;
    const stepPercent = hasActiveSteps ? Math.round(100 / activeSteps.length) : 0;

    return (
        <StatusBox
            title={t("dashboard.enrolmentProgressFor", { firstName: activeStudent.forename })}
            isWarning={completionPercent < 100}
            isSuccess={completionPercent === 100}
        >
            <Preloader isLoading={isLoading}>
                {!hasActiveSteps ? null : (
                    <div className="enrollment-progress">
                        <Stepper className="enrollment-progress__stepper" alternativeLabel>
                            {activeSteps.map(({ key }) => (
                                <Step
                                    key={key}
                                    completed={Boolean(stepsProgress[key]?.completed)}
                                    active={Boolean(stepsProgress[key]?.active)}
                                >
                                    <StepLabel slots={{ stepIcon: StepIcon }} StepIconComponent={StepIcon}>
                                        {`${stepPercent}%`}
                                    </StepLabel>
                                </Step>
                            ))}
                        </Stepper>
                        <Typography color="primary" component="div" className="enrollment-progress__text">
                            {`${t("dashboard.profileCompletion")} ${completionPercent}%`}
                        </Typography>
                    </div>
                )}
            </Preloader>
        </StatusBox>
    );
};

export default EnrollmentProgress;
